export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6427.800ef7ea.jpg";